import { useEffect, useState } from 'react';
import moment from 'moment';

interface UseCountdownProps {
  validFrom: Date;
  validTo: Date;
}

const useCountdown = ({ validFrom, validTo }: UseCountdownProps) => {
  const getInitialTimeLeft = () => {
    const now = moment();
    const from = moment(validFrom);
    const to = moment(validTo);
    if (now.isBefore(from)) {
      return to.diff(from);
    } else {
      return to.diff(now);
    }
  };

  const [timeLeft, setTimeLeft] = useState(getInitialTimeLeft);

  useEffect(() => {
    const from = moment(validFrom);
    const to = moment(validTo);

    const update = () => {
      const now = moment();
      let diff: number;
      if (now.isBefore(from)) {
        diff = to.diff(from);
      } else {
        diff = to.diff(now);
      }
      setTimeLeft(diff > 0 ? diff : 0);
    };

    update();
    if (timeLeft <= 0) return;
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, [validFrom, validTo, timeLeft]);

  const formatTime = (ms: number) => {
    const totalSeconds = Math.floor(ms / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    if (hours > 0) {
      return `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    } else  {
      return `${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`;
    } 
  };

  const formattedTime = timeLeft > 0 ? formatTime(timeLeft) : "00";

  return formattedTime;
};

export default useCountdown;